export enum ApiErrorType {
  NoRolePermission = 'No suitable roles in user',
}
